<app-loader></app-loader>
@if (isBrowserReady) {
	<router-outlet />
}